import * as React from 'react';

import IconButton from 'material-ui/IconButton';
import Help from 'material-ui/svg-icons/action/help';
import { defaultProps } from 'recompose';

const HelpTooltip: React.SFC<{
  help: string;
  tooltipStyles: any;
  tooltipPosition?: 'top-left' | 'top-right' | 'bottom-left';
}> = ({ help, tooltipStyles, tooltipPosition = 'top-left' }) =>
  !!help ? (
    <div className="help">
      <IconButton
        tooltip={<span style={{ whiteSpace: 'normal' }}>{help}</span>}
        touch={true}
        tooltipPosition={tooltipPosition}
        tabIndex={-1}
        tooltipStyles={tooltipStyles}
        style={{ padding: 0, margin: 10, width: 24, height: 24 }}
      >
        <Help focusable="false" />
      </IconButton>
    </div>
  ) : (
    <div />
  );

export default defaultProps({
  tooltipStyles: { width: 350, transition: null }
})(HelpTooltip);



// WEBPACK FOOTER //
// ./src/components/HelpTooltip/HelpTooltip.tsx